import React from 'react';
import { NavLink } from 'react-router-dom';
import './Footer.css'

const Footer = () => {
    return (
        <footer className="text-center text-lg-start text-white bg-dark red-border-top">
            <section className="py-3">
                <div className="container text-center text-md-start mt-5">
                    <div className="row mt-3">
                        {/* About */}
                        <div className="col-md-3 col-lg-4 col-xl-3 mx-auto mb-4">     
                        <h1 className="text-bg fw-bold"><i>LoveTravel</i></h1>          
                            
                            <p>
                            We’ve been the leaders in small group adventure travel for 30 years. How’d we get here? By redefining the way travellers see the world. Check out how we’re creating the future of travel.
                            </p>
                        </div>

                        {/* Service */}
                        <div className="col-md-2 col-lg-2 col-xl-2 mx-auto mb-4">
                            <h6 className="text-uppercase fw-bold metal-font">General</h6>

                            <p>
                                <NavLink to="/events" className="text-white text-decoration-none">
                                Home
                                </NavLink>
                            </p>

                            <p>
                                <NavLink to="/events" className="text-white text-decoration-none">
                                Request a Brochure
                                </NavLink>
                            </p>

                            <p>
                                <NavLink to="/events" className="text-white text-decoration-none">
                                Media Centre
                                </NavLink>
                            </p>

                            <p>
                                <NavLink to="/events" className="text-white text-decoration-none">
                                Affiliate Program
                                </NavLink>
                            </p>

                            <p>
                                <NavLink to="/events" className="text-white text-decoration-none">
                                Contact Us
                                </NavLink>
                            </p>
                        </div>

                        {/* Useful links */}
                        <div className="col-md-3 col-lg-2 col-xl-2 mx-auto mb-4">
                            <h6 className="text-uppercase fw-bold metal-font">About Us</h6>
                           
                            <p>
                                <NavLink to="/" className="text-white text-decoration-none">Our History</NavLink>
                            </p>

                            <p>
                                <NavLink to="/donation" className="text-white text-decoration-none">
                                Our Core Values
                                </NavLink>
                            </p>

                            <p>
                                <NavLink to="/events" className="text-white text-decoration-none">Careers with G</NavLink>
                            </p>

                            <p>
                                <NavLink to="/blog" className="text-white text-decoration-none">
                                Awards
                                </NavLink>
                            </p>
                            <p>
                                <NavLink to="/blog" className="text-white text-decoration-none">
                                Looptail
                                </NavLink>
                            </p>
                        </div>

                        {/* Contact */}
                        <div className="col-md-4 col-lg-3 col-xl-3 mx-auto mb-md-0 mb-4">
                            <h6 className="text-uppercase fw-bold metal-font">Contact</h6>
                          
                            <p><i className="fas fa-home mr-3"></i> Dhaka, Gulshan 1212, Bangladesh</p>
                            <p><i className="fas fa-envelope mr-3"></i> info@love_travel.com</p>
                            <p><i className="fas fa-phone mr-3"></i> +880 199 999 888</p>
                            <p><i className="fas fa-print mr-3"></i> +880 199 999 888</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Copyright */}
            <div
                className="text-center p-3"
                style={{ backgroundColor: "rgba(0, 0, 0, 0.2)" }}
            >
                <span className="me-2">© 2021 Copyright By</span>

                <NavLink to="/" className="text-white text-decoration-none metal-font" href="https://mdbootstrap.com/">
                   SAIFUN NAHAR SUMI
                </NavLink>
            </div>
        </footer>
    );
};

export default Footer;